import { selector } from 'recoil';

import { auth } from 'src/lib/auth';

export const getPrincipalQuery = selector({
    key: 'GetPrincipal',
    get: (): string => {
        const profile = auth.getProfile();

        const id = profile && profile['https://claims.cimpress.io/canonical_id'];

        return typeof (id) === 'string' ? id : '';
    },
});
